import React from 'react'
import { Breadcrumb } from 'semantic-ui-react'
import Conditional from '../../common/Conditional'
import '../Award.css'
export interface IFindMyAwardStep {
  heading: string
  name: string
  done: boolean
  current: boolean
  visible: boolean
  step: number
}

export const FindMyAwardWizardSteps: IFindMyAwardStep[] = [
  {
    heading: 'What to do next',
    name: 'Default',
    done: false,
    current: false,
    visible: false,
    step: 0,
  },
  {
    heading: 'Step 1 - Award coverage',
    name: 'Step 1 - Award coverage',
    done: false,
    current: false,
    visible: true,
    step: 1,
  },
  {
    heading: 'Step 2 - Role & industry is required',
    name: 'Step 2 - Role & industry',
    done: false,
    current: false,
    visible: true,
    step: 2,
  },
  {
    heading: 'Step 3 - Your award',
    name: 'Step 3 - Your award',
    done: false,
    current: false,
    visible: true,
    step: 3,
  },
]

export interface IFindMyAwardWizardBreadcrumbsProps {
  steps: IFindMyAwardStep[]
  indicatorRef: HTMLElement | null
}

const FindMyAwardWizardBreadcrumbs = (
  props: IFindMyAwardWizardBreadcrumbsProps
) => {
  return (
    <>
      <Conditional if={props.steps?.length > 1}>
        <Breadcrumb className="is-linear">
          {props.steps?.map((step, key) => {
            return (
              <Conditional key={key} if={step.visible}>
                <div className="step" key={key}>
                  {step.current ? (
                    <>
                      <div
                        className="indicator is-active"
                        role="progressbar"
                        aria-label={step.name + '. This is the current step'}
                        tabIndex={0}
                        ref={props.indicatorRef}
                      >
                        {step.step}
                      </div>
                      <Breadcrumb.Section active>
                        {step.name}
                      </Breadcrumb.Section>
                    </>
                  ) : (
                    <>
                      <Conditional if={step.done}>
                        <div
                          className="indicator is-done"
                          aria-label={step.name}
                          role="progressbar"
                          tabIndex={-1}
                        >
                          &#x2714;
                        </div>
                      </Conditional>
                      <Conditional if={!step.done}>
                        <div
                          className="indicator"
                          role="progressbar"
                          aria-label={step.name}
                          tabIndex={0}
                        >
                          {step.step}
                        </div>
                      </Conditional>
                      <Breadcrumb.Section>{step.name}</Breadcrumb.Section>
                    </>
                  )}
                </div>
                <Conditional if={step.done}>
                  <span className="separator is-done"></span>
                </Conditional>
                <Conditional if={!step.done}>
                  <span className="separator"></span>
                </Conditional>
              </Conditional>
            )
          })}
        </Breadcrumb>
      </Conditional>
    </>
  )
}

export default FindMyAwardWizardBreadcrumbs
